export const formSection = {
  display: 'flex',
  flexDirection: 'column',
};
